/* eslint-disable filenames/match-regex */

import DashboardService from '@/services/Dashboard';

// The last 7 days up to yesterday (calendar-day arithmetic, so the start stays
// at midnight across daylight saving changes).
const defaultStartDate = new Date();
defaultStartDate.setHours(0, 0, 0, 0);
defaultStartDate.setDate(defaultStartDate.getDate() - 7);

const defaultEndDate = new Date();
defaultEndDate.setHours(0, 0, 0, 0);
defaultEndDate.setMilliseconds(-1);

const state = {
  isLoading: false,
  dashboardData: {},
  brandId: null,
  dateRange: {
    start: defaultStartDate,
    end: defaultEndDate,
  },
};

const getters = {
  isLoading(state) {
    return state.isLoading;
  },

  dashboardData(state) {
    return state.dashboardData;
  },

  brandId(state) {
    return state.brandId;
  },

  dateRange(state) {
    return state.dateRange;
  },
};

const actions = {
  fetch(store) {
    if (store.getters.isLoading) {
      return Promise.resolve();
    }

    store.commit('isLoading', true);

    return DashboardService.get(store.getters.brandId, store.getters.dateRange)
      .then(resp => store.commit('setDashboardData', resp))
      .finally(() => store.commit('isLoading', false));
  },
};

const mutations = {
  isLoading(state, value) {
    state.isLoading = value;
  },

  setDashboardData(state, value) {
    state.dashboardData = value;
  },

  setBrandId(state, value) {
    state.brandId = value;
  },

  setDateRange(state, value) {
    state.dateRange.start = value.start;
    state.dateRange.end = value.end;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
